export const playerTypes = {
    Trailer: 'Trailer',
    LiveTV: 'LiveTV',
    Vod: 'Vod',
    Series: 'Series',
    Catchup: 'Catchup',
    PlayTrailer: 'PlayTrailer',
};

/** Ad types for No Ad CTA configuration (preroll, midroll, postroll) */
export const NO_AD_CTA_AD_TYPES = {
    PREROLL: 'preroll',
    MIDROLL: 'midroll',
    POSTROLL: 'postroll',
} as const;
